/**
 * V70G8J — 타자왕 단어 입력창 붙여넣기·끌어놓기 차단 (게임 입력창 전용)
 *
 * 차단 경로
 *   - paste 이벤트: Ctrl+V / Cmd+V / Shift+Insert / 우클릭 메뉴 [붙여넣기] / 모바일 길게 눌러 [붙여넣기]
 *   - drop 이벤트: 다른 곳의 텍스트를 끌어다 놓기
 *   - beforeinput(inputType): paste/drop 이벤트를 거치지 않는 브라우저 경로(insertFromPaste 등) 2차 차단
 * 허용(차단하지 않음)
 *   - 일반 키 입력(insertText), 한글 IME 조합(insertCompositionText), 삭제 등
 *   - 모바일 자동완성·추천 단어 선택(insertReplacementText)은 타이핑 보조라 막지 않음
 *
 * 한계: 브라우저 밖에서 키 입력을 흉내 내는 자동화 도구(매크로, 일부 모바일 키보드의 클립보드 칩 등)는
 *   일반 타이핑과 같은 이벤트로 들어와 클라이언트에서 구분할 수 없다. 서버 점수 검증(속도 이상 = macro)은 기존 그대로.
 */

/** 차단할 beforeinput inputType */
export const BLOCKED_INPUT_TYPES: ReadonlySet<string> = new Set([
  'insertFromPaste',
  'insertFromPasteAsQuotation',
  'insertFromDrop',
  'insertFromYank',
]);

export type PasteBlockSource = 'paste' | 'drop' | 'beforeinput';

/**
 * 입력 요소에 차단 리스너를 붙이고 해제 함수를 반환한다.
 * onBlocked 는 사용자 안내 표시용 (선택).
 */
export function attachPasteGuard(
  el: HTMLElement,
  onBlocked?: (source: PasteBlockSource) => void,
): () => void {
  const block = (source: PasteBlockSource) => (e: Event) => {
    e.preventDefault();
    onBlocked?.(source);
  };
  const onPaste = block('paste');
  const onDrop = block('drop');
  const onBeforeInputBlock = block('beforeinput');
  const onBeforeInput = (e: Event) => {
    const type = (e as InputEvent).inputType;
    if (type && BLOCKED_INPUT_TYPES.has(type)) onBeforeInputBlock(e);
  };
  el.addEventListener('paste', onPaste);
  el.addEventListener('drop', onDrop);
  el.addEventListener('beforeinput', onBeforeInput);
  return () => {
    el.removeEventListener('paste', onPaste);
    el.removeEventListener('drop', onDrop);
    el.removeEventListener('beforeinput', onBeforeInput);
  };
}
